var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read-time"},[_c('i',{staticClass:"far fa-clock"}),_vm._v(" "),_c('span',{staticClass:"read-time__minutes"},[_vm._v("\n        "+_vm._s(_vm.$translate('wpm_read', '{readTime} min')
            .replace('{readTime}', _vm.formatReadMinutes))+" \n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }